/**
 * @generated SignedSource<<b5e6772aed9ee2c1941ca26e43ab4284>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExternalPaymentProvider = "EDUZZ" | "GREENN" | "GURU" | "HEROSPARK" | "HOTMART" | "HUBLA" | "KIRVANO" | "KIWIFY" | "SCARF_PAY" | "STRIPE" | "TICTO" | "TMB" | "%future added value";
export type PaymentIntegrationCreateInput = {
  hash: string;
  products: ReadonlyArray<PaymentIntegrationProductCreateInput>;
  provider: ExternalPaymentProvider;
};
export type PaymentIntegrationProductCreateInput = {
  accessDefaultDuration?: number | null | undefined;
  accessgroup: AccessGroupCreateInput;
  basePrice?: string | null | undefined;
  checkoutUrl?: string | null | undefined;
  description?: any | null | undefined;
  enabled?: boolean;
  productId?: string | null | undefined;
  productName: string;
};
export type AccessGroupCreateInput = {
  badges?: ReadonlyArray<string> | null | undefined;
  courses?: ReadonlyArray<UpdateCourseProductInput> | null | undefined;
  spaces?: ReadonlyArray<string> | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
};
export type UpdateCourseProductInput = {
  id: string;
  memberGroup?: string | null | undefined;
};
export type integracoesCheckoutNovoMutation$variables = {
  club: string;
  input: PaymentIntegrationCreateInput;
};
export type integracoesCheckoutNovoMutation$data = {
  readonly paymentIntegrationCreate: {
    readonly id: string;
  };
};
export type integracoesCheckoutNovoMutation = {
  response: integracoesCheckoutNovoMutation$data;
  variables: integracoesCheckoutNovoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "club",
        "variableName": "club"
      },
      {
        "kind": "Variable",
        "name": "paymentIntegrationCreateInput",
        "variableName": "input"
      }
    ],
    "concreteType": "PaymentIntegration",
    "kind": "LinkedField",
    "name": "paymentIntegrationCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "integracoesCheckoutNovoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "integracoesCheckoutNovoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94ab2127f69b9a652699fa7df98147fc",
    "id": null,
    "metadata": {},
    "name": "integracoesCheckoutNovoMutation",
    "operationKind": "mutation",
    "text": "mutation integracoesCheckoutNovoMutation(\n  $club: String!\n  $input: PaymentIntegrationCreateInput!\n) {\n  paymentIntegrationCreate(club: $club, paymentIntegrationCreateInput: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2673d98f99920b4881891bea805608ed";

export default node;
